import { addTranslation, i18n, setTankerProjectId } from '@ps-int/react-tanker';
import { tankerTranslations } from './translations';

export type Language = keyof typeof tankerTranslations;
export type TranslationKey = keyof typeof tankerTranslations.en;

setTankerProjectId('front-ps-tuning');

type TranslationLookup = Record<string, () => string>;

(['ru', 'en'] as const).forEach(language => {
    const keyset = Object.keys(tankerTranslations[language]).reduce<TranslationLookup>((keys, key) => {
        keys[key] = () => tankerTranslations[language][key as TranslationKey];

        return keys;
    }, {});

    addTranslation(language, {
        'front-ps-tuning': {
            onpremland: keyset,
        },
    });
});

export const translate = (
    language: Language,
    key: TranslationKey,
    params: Record<string, string | number> = {},
): string => {
    const value = i18n(language, 'onpremland', key);

    return (value ?? key).replace(/\{([^}]+)\}/g, (_, name: string) => String(params[name] ?? ''));
};
